module.exports = __webpack_public_path__ + "assets/f8e6f27daec6913e3469235a424d4f84.mp4";